// Utility helpers for event date/time calculations
// Returns true if the event is past (ended) based on available date/time fields
export function parseDateTime(dateString, timeString) {
  try {
    if (!dateString) return null;
    if (timeString) {
      // Try ISO combine
      const dt = new Date(`${dateString}T${timeString}`);
      if (!isNaN(dt.getTime())) return dt;
    }

    // Fallback to date only
    const d = new Date(dateString);
    if (!isNaN(d.getTime())) return d;
    return null;
  } catch (err) {
    return null;
  }
}

export function getEventEndDate(event) {
  if (!event) return null;

  // Priority: endDate+endTime -> endDate (end of day) -> date+endTime -> date+startTime -> date (end of day)
  let dt = null;

  dt = parseDateTime(event.endDate, event.endTime);
  if (dt) {
    // if endDate present but no endTime, parseDateTime returned date at midnight; set to end of day
    if (!event.endTime) dt.setHours(23,59,59,999);
    return dt;
  }

  dt = parseDateTime(event.date, event.endTime);
  if (dt) return dt;

  dt = parseDateTime(event.date, event.startTime);
  if (dt) return dt;

  // fallback to event.date end of day
  dt = parseDateTime(event.date, null);
  if (dt) { dt.setHours(23,59,59,999); return dt; }

  return null;
}

export function isEventPast(event) {
  const end = getEventEndDate(event);
  if (!end) return false; // if we can't determine, assume not past to avoid false blocks
  return Date.now() > end.getTime();
}
